module.exports = __webpack_public_path__ + "static/media/brandName.5d932b5b.png";